import { GameModeLogic } from "../types/GameModeLogic";
import { ActionResult } from "../types/ComponentTypes";

const animalLogic: GameModeLogic = {
  async loadToCarrier({ character, platforms, platformKey }) {
    const carrierHasOne = platforms.Carrier.length === 1;
    const replaced = carrierHasOne ? platforms.Carrier[0] : null;

    const animatedCharacters = replaced
      ? [replaced.name, character.name]
      : [character.name];

    const newSource = platforms[platformKey].filter(
      (c) => c.name !== character.name,
    );

    return {
      result: ActionResult.OK,
      animatedCharacters,
      nextPlatforms: {
        ...platforms,
        Carrier: [character],
        [platformKey]: replaced
          ? [...newSource, replaced]
          : newSource,
      },
    };
  },
};
export const familyLogic: GameModeLogic = {
  async loadToCarrier({ character, platforms, platformKey, setMessage }) {
    const newCarrier = [...platforms.Carrier, character];

    const adults = newCarrier.filter(c => c.type === "adult").length;
    const children = newCarrier.filter(c => c.type === "child").length;

    if (newCarrier.length > 2) {
      setMessage("В скутере максимум 2 человека");
      return { result: ActionResult.INVALID };
    }

    if (adults === 2) {
      setMessage("Два взрослых не могут ехать вместе");
      return { result: ActionResult.INVALID };
    }

    if (adults === 1 && children === 1) {
      setMessage("Взрослый не может ехать с ребёнком");
      return { result: ActionResult.INVALID };
    }

    return {
      result: ActionResult.OK,
      animatedCharacters: [character.name],
      nextPlatforms: {
        ...platforms,
        Carrier: newCarrier,
        [platformKey]: platforms[platformKey].filter(
          c => c.name !== character.name
        ),
      },
    };
  },
};
export const LoadLogic = {
  animal: animalLogic,
  family: familyLogic,
} as const;